<template>
  <div class="about_intro">
    <div class="about_intro_title">简介</div>
    <br>
    <p>东群教育科技是山东省齐鲁股权交易中心挂牌上市企业，股权代码302987，现股价4.8元一股；公司成立于2016年，办学宗旨：授业解惑，广育英才。现每年线下培训考证学员5000多名。</p>
    <br>
    <p>公司目前主要以线上线下开展教师培训、会计培训、计算机培训、银行证券等资格类考证培训和创业培训为主营业务。</p>
    <br>
    <p>东群通过目前所开展的高质量、高通过率的培训业务，倾心优质服务了近2万多名学员，在山东地区具有很强的品牌影响力，并已成功挂牌上市。培训业务及互联网＋资格类培训的创新也获得了团中央、省人社厅、市团委以及山东众多高校的认可，并获得了一系列国家级、省级、市级奖项。</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
.about_intro_title {
  font-size: 20px;
  border-bottom: 1px dotted #cccccc;
  color: #00ad74;
  line-height: 40px;
}
.about_intro p {
  font-size: 14px;
  font-weight: lighter;
  text-indent: 2em;
  line-height: 28px;
}
</style>
